

let treeChildren = (index, data) => {
  var arr = [];
  if (data) {
    var li = [1, 2, 3, 4, 5, 6, '大', '小', '单', '双'];
    var str = [1, 2, 3, 4, 5, 6, 'big', 'small', 'single', 'double'];
    for (let i = 0; i < li.length; i++) {
      var obj = {};
      obj.title = `${li[i]}`;
      obj.align = 'center';
      obj.width = '37';
      obj.className = `tree_table_children_${index}`;
      obj.render = (h, row) => {
        // return <span>3</span>;
        var name = `ball${index + 1}`;
        if (i < 6) {
          var divideList = data[0].ball_json[name].nums[i + 1];
          var n = row.row.ball_json[name].nums[i + 1];

          if (n == 0) {
            return <span class="red">{row.row.ballList[index]}</span>;
          } else if (divideList > row.index) {
            return <span class="divide_lost_info lost_info">{n}</span>;
          } else {
            return <span class="lost_info">{n}</span>;
          }
          // } else {
          //   return <span class="lost_info">{row.row.ball_json[name].nums[i + 1]}</span>;
          // }
        } else if (5 < i && i < 8) {
          var divideList = data[0].ball_json[name].ballBigSmall[str[i]];
          var n = row.row.ball_json[name].ballBigSmall[str[i]];

          if (n == 0) {
            return <span class={`table_join_${i % 2}`}>{li[i]}</span>;
          } else if (divideList > row.index) {
            return <span class="divide_lost_info lost_info">{n}</span>;
          } else {
            return <span class="lost_info">{n}</span>;
          }
          // } else {
          //   return <span class="table_join">{row.row.ball_json[name].ballBigSmall[str[i]]}</span>;
          // }
        } else {
          var divideList = data[0].ball_json[name].ballSingleDouble[str[i]];
          var n = row.row.ball_json[name].ballSingleDouble[str[i]];
          if (row.row.ball_json[name].ballSingleDouble[str[i]] == 0) {
            return <span class={`table_join_${i % 2}`}>{li[i]}</span>;
          } else if (divideList > row.index) {
            return <span class="divide_lost_info lost_info">{n}</span>;
          } else {
            return <span class="lost_info">{n}</span>;
          }
          // } else {
          //   return <span class="table_join">{row.row.ball_json[name].ballSingleDouble[str[i]]}</span>;
          // }
        }
      };
      arr.push(obj);
    }
    return arr;
  }
};

let lostTreeChildren = (index, data) => {
  var arr = [];
  if (data) {
    var li = [1, 2, 3, 4, 5, 6, '大', '小', '单', '双'];
    var str = [1, 2, 3, 4, 5, 6, 'big', 'small', 'single', 'double'];
    for (let i = 0; i < li.length; i++) {
      var obj = {};
      obj.title = `${li[i]}`;
      obj.align = 'center';
      obj.width = '37';
      obj.className = `tree_table_children_${index}`;
      obj.render = (h, row) => {
        var name = `ball${index + 1}`;
        var key = row.row.key;
        var n = row.row.lost.ballJson[name];
        if (i < 6) {
          return <span>{n.nums[str[i]][key] ? n.nums[str[i]][key] : 0}</span>;
        } else if (5 < i && i < 8) {
          return <span>{n.ballBigSmall[str[i]][key] ? n.ballBigSmall[str[i]][key] : 0}</span>;
        } else {
          return <span>{n.ballSingleDouble[str[i]][key] ? n.ballSingleDouble[str[i]][key] : 0}</span>;
        }
      };
      arr.push(obj);
    }
    return arr;
  }
};
const ssc = (data, ballindex) => {
  var ball = ['一', '二', '三', '四', '五'];

  let list = Vue => {
    let arr = [
      {
        title: '期数',
        align: 'center',
        key: 'issue_id',
        className: `table_issueId`,
        width: 172
      },
      {
        title: '开奖号码',
        align: 'center',
        width: 172,
        className: `table_issueId`,
        render: (h, { row }) => <span class="issue_result">{row.balls.split(',').join('')}</span>
      },
      {
        title: `第一球号码走势`,
        align: 'center',
        width: 300,
        className: `table_issueId`,
        children: treeChildren(0, data)
      },
      {
        title: `第二球号码走势`,
        align: 'center',
        width: 300,
        className: `table_issueId`,
        children: treeChildren(1, data)
      },
      {
        title: `第三球号码走势`,
        align: 'center',
        width: 300,
        className: `table_issueId`,
        children: treeChildren(2, data)
      }
    ];

    return arr;
  };
  let lostList = Vue => {
    let arr = [
      {
        title: '数据统计',
        align: 'center',
        key: 'name',
        className: `table_issueId`,
        width: 320
      },
      {
        title: `第一球号码走势`,
        align: 'center',
        width: 300,
        className: `table_issueId`,
        children: lostTreeChildren(0, data)
      },
      {
        title: `第二球号码走势`,
        align: 'center',
        width: 300,
        className: `table_issueId`,
        children: lostTreeChildren(1, data)
      },
      {
        title: `第三球号码走势`,
        align: 'center',
        width: 300,
        className: `table_issueId`,
        children: lostTreeChildren(2, data)
      }
    ];

    return arr;
  };
  let describe =
    '<p>大小 : 1、2、3为小，4、5、6为大。</p>' +
    '<p>单双：1、3、5为单，2、4、6为双</p>' +
    '<p>遗漏期数：自上期开出到本期间隔的期数。</p>' +
    '<p>出现次数：统计周期内，某个号码的累计出现次数。</p>' +
    '<p>最大遗漏：是指统计周期内所有遗漏值的最大值。</p>' +
    '<p>最大连出：是指统计周期内所有连出值的最大值。</p>';
  return { list, lostList, describe };
};

export default ssc;



// WEBPACK FOOTER //
// ./src/pages/Trend/Dingweizoushi/columns/ks.js